function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 750,
  cy: 750,
  r: 750,
  fill: "#0B2952"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M395 697v406H231V393h128l331 417V393h164v710H722L395 697z",
  fill: "#F0AB25"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M854 1103L690 393h265c58.67 0 110 9.333 154 28s80.67 44 110 76c30 32 52.33 69.667 67 113 15.33 42.667 23 88.333 23 137 0 54-8.33 103-25 147-16.67 43.333-40.67 80.667-72 112-30.67 30.67-68 54.67-112 72-43.33 16.67-91.67 25-145 25H854zm288-356c0-31.333-4.33-59.667-13-85-8-26-20-48.333-36-67s-35.67-33-59-43-49.667-15-79-15H854v422h101c30 0 56.67-5.333 80-16s42.67-25.333 58-44c16-19.333 28-41.667 36-67 8.67-26 13-54.333 13-85z",
  fill: "#F0AB25"
});

var SvgLogo = function SvgLogo(props) {
  return React.createElement("svg", _extends({
    width: 1500,
    height: 1500,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUwMCIgaGVpZ2h0PSIxNTAwIiB2aWV3Qm94PSIwIDAgMTUwMCAxNTAwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8Y2lyY2xlIGN4PSI3NTAiIGN5PSI3NTAiIHI9Ijc1MCIgZmlsbD0iIzBCMjk1MiIvPgo8cGF0aCBkPSJNMzk1IDY5N1YxMTAzSDIzMVYzOTNIMzU5TDY5MCA4MTBWMzkzSDg1NFYxMTAzSDcyMkwzOTUgNjk3WiIgZmlsbD0iI0YwQUIyNSIvPgo8cGF0aCBkPSJNODU0IDExMDNMNjkwIDM5M0g5NTVDMTAxMy42NyAzOTMgMTA2NSA0MDIuMzMzIDExMDkgNDIxQzExNTMgNDM5LjY2NyAxMTg5LjY3IDQ2NSAxMjE5IDQ5N0MxMjQ5IDUyOSAxMjcxLjMzIDU2Ni42NjcgMTI4NiA2MTBDMTMwMS4zMyA2NTIuNjY3IDEzMDkgNjk4LjMzMyAxMzA5IDc0N0MxMzA5IDgwMSAxMzAwLjY3IDg1MCAxMjg0IDg5NEMxMjY3LjMzIDkzNy4zMzMgMTI0My4zMyA5NzQuNjY3IDEyMTIgMTAwNkMxMTgxLjMzIDEwMzYuNjcgMTE0NCAxMDYwLjY3IDExMDAgMTA3OEMxMDU2LjY3IDEwOTQuNjcgMTAwOC4zMyAxMTAzIDk1NSAxMTAzSDg1NFpNMTE0MiA3NDdDMTE0MiA3MTUuNjY3IDExMzcuNjcgNjg3LjMzMyAxMTI5IDY2MkMxMTIxIDYzNiAxMTA5IDYxMy42NjcgMTA5MyA1OTVDMTA3NyA1NzYuMzMzIDEwNTcuMzMgNTYyIDEwMzQgNTUyQzEwMTAuNjcgNTQyIDk4NC4zMzMgNTM3IDk1NSA1MzdIODU0Vjk1OUg5NTVDOTg1IDk1OSAxMDExLjY3IDk1My42NjcgMTAzNSA5NDNDMTA1OC4zMyA5MzIuMzMzIDEwNzcuNjcgOTE3LjY2NyAxMDkzIDg5OUMxMTA5IDg3OS42NjcgMTEyMSA4NTcuMzMzIDExMjkgODMyQzExMzcuNjcgODA2IDExNDIgNzc3LjY2NyAxMTQyIDc0N1oiIGZpbGw9IiNGMEFCMjUiLz4KPC9zdmc+Cg==";
export { SvgLogo as ReactComponent };